import { Check } from 'lucide-react';
import { NeobrutalButton } from '@/components/marketing/v2/NeobrutalButton';
import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

const INCLUDED: ReadonlyArray<string> = [
  'Activable quand tu es prêt',
  'Aucun impact sur ta caisse classique',
  'Idéal bar, lounge, restaurant, snack',
  'Fonctionne hors ligne au comptoir',
];

export default function BarPremiumV2() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="mx-auto max-w-5xl px-6 md:px-8">
        <div className="border-[3px] border-charcoal-800 bg-paper p-8 shadow-neobrutal-lime-10 md:p-12">
          <div className="grid items-center gap-10 md:grid-cols-[1.1fr_0.9fr]">
            <div>
              <SectionLabel>Module en option</SectionLabel>
              <h2 className="mt-3 font-marketing-display text-[clamp(28px,3.8vw,48px)] font-bold leading-[1.05] tracking-[-0.035em] text-charcoal-800">
                Le contrôle bar, <span className="underline-lime">quand tu le décides.</span>
              </h2>
              <p className="mt-4 max-w-md font-marketing-body text-[16px] leading-[1.55] text-charcoal-600">
                Velko Bar est un module premium. Tu gardes ta caisse Velko habituelle, et tu actives le
                contrôle des coûts le jour où tu en as besoin — sans migration, sans réinstaller quoi
                que ce soit.
              </p>

              <div className="mt-8 flex flex-wrap items-center gap-4">
                <NeobrutalButton as="link" to="/tarifs" variant="primary" size="lg">
                  Voir les tarifs
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <path d="M5 12h14" />
                    <path d="M13 6l6 6-6 6" />
                  </svg>
                </NeobrutalButton>
                <NeobrutalButton as="link" to="/contact" variant="secondary" size="lg">
                  Parler à l'équipe
                </NeobrutalButton>
              </div>
            </div>

            <ul className="space-y-3">
              {INCLUDED.map((item) => (
                <li
                  key={item}
                  className="flex items-center gap-3 border-2 border-charcoal-800 bg-white px-4 py-3 font-marketing-body text-[14.5px] text-charcoal-800 shadow-neobrutal-2"
                >
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center border-2 border-charcoal-800 bg-lime-500 text-charcoal-800">
                    <Check className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" />
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
